import request from '../request'
export function findByNewsId(newsId){
  return request({
    url: '/rest/wLocalStorage/findByNewsId',
    method: 'get',
    params: {
      newsId: newsId
    }
  })
}

export function download(storageId){
  return request({
    url: '/rest/wLocalStorage/download',
    method: 'get',
    params: {
      storageId: storageId
    },
    responseType: "blob"
  })
}

// 下载文件
export function downloadFileT(obj, name) {
  const url = window.URL.createObjectURL(new Blob([obj]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', name)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export default { findByNewsId,download,downloadFileT }


// WEBPACK FOOTER //
// ./src/http/web/localStorage.js